/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unused-expressions */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-unnecessary-type-assertion */
import {useState} from 'react';
import {Dropdown, FormControl, InputGroup} from 'react-bootstrap';
import CustomMenu from './CustomMenu';

interface CustomDropdownProps {
	options: string[];
	onSelect: (name: string[], option: string) => void;
	selectedValue: string;
	requiredValue: boolean;
	nameDropdown: string;
}

const DropdownSumma = ({
	options,
	onSelect,
	selectedValue,
	requiredValue,
	nameDropdown,
}: CustomDropdownProps) => {
	const [show, setShow] = useState(false);

	const handleSelect = (option: string) => {
		onSelect([nameDropdown], option);
		setShow(false);
	};

	const handleToggle = (isOpen: boolean) => {
		setShow(isOpen);
	};

	return (
		<InputGroup className="mb-3">
			<FormControl
				name={nameDropdown}
				value={selectedValue}
				aria-label={nameDropdown}
				onClick={() => setShow(true)}
				placeholder="Select an option"
				className="no-text-cursor"
				required={requiredValue}
				readOnly
			/>
			<Dropdown show={show} onToggle={handleToggle} drop="down">
				<Dropdown.Menu as={CustomMenu} isOpen={show}>
					{options.map((option: string, index: number) => (
						<Dropdown.Item key={index} onClick={() => handleSelect(option)}>
							{option}
						</Dropdown.Item>
					))}
				</Dropdown.Menu>
			</Dropdown>
		</InputGroup>
	);
};

export default DropdownSumma;
